import { CastType } from '../../../../../types';

export const isEpochCastType = (castType?: CastType | null) =>
  castType === CastType.EPOCHS_MILLIS || castType === CastType.EPOCHS_SECS;
